export default "__VITE_ASSET__C3H9XfvD__"